<section class="staffing-grid-input">
    <div>
        <span>Block Size (In Hours)</span>
        <span>Start Time</span>
    </div>
    <div>
        <input type="text" disabled [value]="4">
        <select name="shiftBlockHour" id="shiftBlockHourDropdown" class="body-dropdown"
            (change)="onChangeStartHour()" [disabled]="blockSizeSaved()" [(ngModel)]="selectedShiftBlockHour">
            <option *ngFor="let shiftBlockHour of shiftBlockStartHours" [ngValue]="shiftBlockHour.hour">
                {{ shiftBlockHour.description }}
            </option>
        </select>
    </div>
</section>
